<template>
  <div>
    <van-form>
      <van-field label="订单号">
        <template #input>
          <span style="margin-right: 15px">{{ form.order_no }}</span
          ><van-icon name="replay" @click="setAddress" />
        </template>
      </van-field>
      <van-field label="地址">
        <template #input>
          <span
            >{{ form.receiver_name }}({{ form.receiver_mobile }}),<span style="color: red; font-size: 19px">{{ form.prov_name }}</span
            >{{ form.city_name }}{{ form.area_name }}{{ form.address }}</span
          >
        </template>
      </van-field>
      <van-field label="支付金额">
        <template #input>
          <span>{{ form.pay_amount }}元</span>
        </template>
      </van-field>
      <van-field label="主图">
        <template #input>
          <img :src="form.image" style="width: 30%; height: 30%" />
        </template>
      </van-field>
      <van-field label="书本标题">
        <template #input>
          <span>{{ form.title }}</span>
        </template>
      </van-field>
      <van-field label="规格名" v-if="form.sku_text">
        <template #input>
          <span>{{ form.sku_text }}</span>
        </template>
      </van-field>
      <van-field label="书本ISBN">
        <template #input>
          <span>{{ form.isbn }}</span>
        </template>
      </van-field>
      <van-field label="购买">
        <template #input>
          <a v-if="form.kongfz_book_id" style="color:#1989fa" @click="openUrl(form.kongfz_book_id, 3)">去购买商品</a>
          <a v-else style="color:#1989fa" >未按软件要求填写无法一键购买，推荐使用软件上书</a>
        </template>
      </van-field>
      <van-field label="购买数量">
        <template #input>
          <span v-if="form.quantity === 1">{{ form.quantity }}</span>
          <span v-else style="color: red; font-size: 25px">{{ form.quantity }}(注意购买数量)</span>
        </template>
      </van-field>
      <van-field label="购买成本" v-model="form.cost_amount" placeholder="输入购买成本(元)" />
      <van-field label="孔夫子订单号">
        <template #input>
          <van-field v-for="(item, index) in form.sons" :key="index" v-model="item.k_order" placeholder="输入孔夫子单号" />
          <van-icon name="add-o" @click="addSonOrder" />
        </template>
      </van-field>
      <van-field label="备注" v-model="form.remark" placeholder="备注" />
      <div style="margin: 16px">
        <van-button round block type="info" @click="updateOrder">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      order_no: '',
      form: {
        order: ''
      }
    }
  },
  created() {
    console.log(this.$route.query.order_no)
    this.order_no = this.$route.query.order_no
    if (this.order_no) {
      this.getMyOrderDetail()
    }
  },
  methods: {
    openUrl(isbn, type) {
      if (type === 0) {
        window.open('https://search.kongfz.com/item_result/?key=' + isbn, '_blank')
      } else if (type === 2) {
        window.open('https://shop.kongfz.com/buyer/order/order_detail.html?orderId=' + isbn, '_blank')
      } else if (type === 3) {
        window.open('https://m.kongfz.com/item/' + isbn, '_blank')
      } else {
        window.open('https://www.goofish.pro/product/edit?product_id=' + isbn, '_blank')
      }
    },
    addSonOrder() {
      this.form.sons.push({
        k_order: ''
      })
    },
    async setAddress() {
      const { data: res } = await this.$http.get('goofish/order/setAddress?order_no=' + this.order_no)
      if (res.code === 200) {
        this.$toast(res.data)
      }
    },
    async updateOrder() {
      const { data: res } = await this.$http.post('goofish/order/update', this.form)
      if (res.code === 200) {
        this.$toast(res.msg)
      }
    },
    async getMyOrderDetail() {
      const { data: res } = await this.$http.get('goofish/order/myOrderDetail?order_no=' + this.order_no)
      if (res.code === 200) {
        this.form = res.data
        if (this.form.sons.length === 0) {
          this.form.sons.push({
            k_order: ''
          })
        }
      }
    }
  },
  components: {}
}
</script>

<style scoped>
.header {
  background: #4a4a56;
  padding: 2rem;
  text-align: center;
}
.header div {
  text-align: center;
  color: #c2c4d4;
  font-size: 16px;
}
.van-image {
  width: 80%;
}
.text {
  color: #8d9da7;
  padding: 1rem;
}
.text_1 {
  color: #f10e0e;
  padding: 1rem;
}
.mod {
  margin: 1rem;
  text-align: center;
}
</style>
